module.exports = __webpack_public_path__ + "static/Arre-60ff68efb650945debd78b540550b0d7.png";